import { alpha, Box, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCloudUpload } from '@tabler/icons-react';
import React from 'react';

import classes from './DropOverlay.module.css';

export interface IDropOverlayProps {
  title: string;
  description?: string;
}

/** @registry Dashed drag-and-drop target overlay filling its (position:relative) parent pane; render inside Dropzone.Accept instead of a hand-rolled absolute overlay. */
export const DropOverlay: React.FC<IDropOverlayProps> = ({
  title,
  description,
}) => (
  <Box
    className={classes.overlay}
    style={
      {
        '--drop-overlay-fill': alpha('var(--mantine-color-blue-1)', 0.6),
      } as React.CSSProperties
    }
  >
    <Stack align="center" gap="xs">
      <ThemeIcon variant="light" size="xl">
        <IconCloudUpload size={24} />
      </ThemeIcon>
      <Text fw={600}>{title}</Text>
      {description && (
        <Text size="sm" c="dimmed">
          {description}
        </Text>
      )}
    </Stack>
  </Box>
);
